import {
  appendPropagatedParameters,
  addLocaleToPath,
  getCurrentLocale,
} from 'app/history';

// Base path of the "Add to Apple Wallet" page. It is served by a separate
// project behind an nginx reverse proxy (like the new checkout), so links to
// it must be full-page navigations, not client-side react-router transitions.
export const APPLE_WALLET_PATH = '/reservations';

/**
 * Build the URL to the Apple Wallet page for a reservation. The path carries
 * the currently active locale (e.g. `/en-us/reservations/<id>/apple-wallet`)
 * and any params that must be propagated across pages (`ref`, `wl`, `utm_*`,
 * ...) from the current URL.
 * @param  {string} reservationId
 * @return {string}
 */
export const getAppleWalletUrl = (reservationId) => {
  const path = addLocaleToPath(
    `${APPLE_WALLET_PATH}/${reservationId}/apple-wallet`,
    getCurrentLocale()
  );
  return appendPropagatedParameters(path);
};
